import { X } from "lucide-react";

const CloseButton = ({ onClick }) => {
    return (
         <button
            className="absolute top-3 right-3 text-primary-dark hover:text-accent-main"
            onClick={onClick}
            aria-label="Close"
          >
            <X className="h-6 w-6" />
          </button>
    );
}

export default CloseButton;